import _ from 'lodash';
import { reset } from 'redux-form';

export const PROFILE_FORM = 'PROFILE_FORM';
export const PROFILE_CHANGE_PASSWORD_FORM = 'PROFILE_CHANGE_PASSWORD_FORM';
export const NEW_ACCOUNT_FORM = 'newAccount';
export const PAYMENT_FORM = 'payment';
export const SAVE_ACCOUNT_FORM = 'saveAccount';

const ALL_FORMS = [
  PROFILE_FORM,
  PROFILE_CHANGE_PASSWORD_FORM,
  NEW_ACCOUNT_FORM,
  PAYMENT_FORM,
  SAVE_ACCOUNT_FORM,
];

export function clearForms() {
  return (dispatch) => _.each(ALL_FORMS, (form) => dispatch(reset(form)));
}

export function clearForm(form) {
  return (dispatch) => dispatch(reset(form));
}
